export const stripeUrl = 'https://buy.stripe.com/'
export default stripeUrl
